import { Moment } from 'moment'

import { DefaultFile, EmptyDefaultFile } from 'Core/interfaces'
import { StateProvince } from 'Core/utils/storeHelpers/types'

export enum RegistrationDocumentDocumentFields {
	id = 'id',
	documentType = 'documentType',
	documentName = 'documentName',
	uploadedBy = 'uploadedBy',
	uploadDate = 'uploadDate',
	isRequired = 'isRequired'
}

export enum RegistrationDocumentUploadDocumentFormFields {
	file = 'file',
	documentTypeId = 'documentTypeId'
}

export enum CustomerRegistrationRequestStatus {
	requested = 'Requested',
	completed = 'Completed',
	updatedByCustomer = 'Updated By Customer'
}

export declare namespace RegistrationDocument {
	interface Basic {
		id: number
		customerName: BasicString
		customerEmailAddress: BasicString
		customerPhoneNumber: BasicString
		customerWebsite: BasicString
		parentCompany: BasicString
		status: Entity<CustomerRegistrationRequestStatus> | null
		ownershipType: Entity | null
		doingBusinessAs: BasicString
		yearBusinessEstablished: BasicNumber
		principalName: BasicString
		stateProvince: StateProvince | null
		companyWebsiteAddress: BasicString
		dunsNumber: BasicString
		federalTaxId: BasicString
		naicsCode: BasicString
		companyPartyToAnyClaimOrLawsuit: boolean
		taxLinesAgainstCompany: boolean
		companyFiledBankruptcy: boolean
		bankruptcyType: Entity | null
		dateFilingBankruptcy: string
	}

	interface Form {
		customerName: BasicString
		customerPhoneNumber: BasicString
		customerEmailAddress: BasicString
		customerWebsite: BasicString
		parentCompany: BasicString
		ownershipTypeId: BasicNumber
		doingBusinessAs: BasicString
		yearBusinessEstablished: Moment | null
		principalName: BasicString
		stateProvinceId: BasicNumber
		companyWebsiteAddress: BasicString
		dunsNumber: BasicString
		federalTaxId: BasicString
		naicsCode: BasicString
		companyPartyToAnyClaimOrLawsuit: boolean
		taxLinesAgainstCompany: boolean
		companyFiledBankruptcy: boolean
		bankruptcyTypeId: BasicNumber
		dateFilingBankruptcy: Moment | null
		isRequiredSchema: boolean
	}

	interface Request {
		customerName: BasicString
		customerPhoneNumber: BasicString
		customerEmailAddress: BasicString
		customerWebsite: BasicString
		parentCompany: BasicString
		ownershipTypeId: BasicNumber
		doingBusinessAs: BasicString
		yearBusinessEstablished: BasicNumber
		principalName: BasicString
		stateProvinceId: BasicNumber
		companyWebsiteAddress: BasicString
		dunsNumber: BasicString
		federalTaxId: BasicString
		naicsCode: BasicString
		companyPartyToAnyClaimOrLawsuit: boolean
		taxLinesAgainstCompany: boolean
		companyFiledBankruptcy: boolean
		bankruptcyTypeId: BasicNumber
		dateFilingBankruptcy: BasicString
	}

	namespace Document {
		interface Basic {
			[RegistrationDocumentDocumentFields.id]: number
			[RegistrationDocumentDocumentFields.documentType]: Nullable<Entity>
			[RegistrationDocumentDocumentFields.documentName]: BasicString
			[RegistrationDocumentDocumentFields.uploadDate]: BasicString
			[RegistrationDocumentDocumentFields.isRequired]: boolean
		}

		interface Form {
			[RegistrationDocumentUploadDocumentFormFields.file]: Nullable<
				DefaultFile | EmptyDefaultFile
			>
			[RegistrationDocumentUploadDocumentFormFields.documentTypeId]: BasicNumber
		}

		interface Request {
			[RegistrationDocumentUploadDocumentFormFields.file]: Nullable<File>
			[RegistrationDocumentUploadDocumentFormFields.documentTypeId]: BasicNumber
		}
	}

	namespace ServiceLocation {
		interface Basic {
			id: number
			name: BasicString
			brandName: BasicString
			addressLine1: BasicString
			addressLine2: BasicString
			country: Nullable<IdCodeName>
			stateProvince: Nullable<StateProvince & { countryId: number }>
			county: Nullable<Entity>
			city: BasicString
			zipCode: BasicString
			contactName: BasicString
			contactTitle: BasicString
			contactEmail: BasicString
			contactPhoneNumber: BasicString
		}

		namespace Form {
			interface Generic {
				name: BasicString
				brandName: BasicString
				addressLine1: BasicString
				addressLine2: BasicString
				countryId: BasicNumber
				stateProvinceId: BasicNumber
				city: BasicString
				zipCode: BasicString
				countyId: BasicNumber
				contactName: BasicString
				contactTitle: BasicString
				contactEmail: BasicString
				contactPhoneNumber: BasicString
			}
		}
		namespace Request {
			interface Generic {
				name: BasicString
				brandName: BasicString
				addressLine1: BasicString
				addressLine2: BasicString
				countryId: BasicNumber
				stateProvinceId: BasicNumber
				countyId: BasicNumber
				city: BasicString
				zipCode: BasicString
				contactName: BasicString
				contactTitle: BasicString
				contactEmail: BasicString
				contactPhoneNumber: BasicString
			}
		}
	}
}
